/* ============================================================================
   MB multibuy - "Single Card" | "Multi-Card" (Moonpig pattern)
   assets/mb-multibuy.js  (markup: snippets/mb-multibuy.liquid,
                           loaded from sections/mb-delivery.liquid)

   An additive layer in the same style as mb-flow-revisions.js: mb-flow.liquid
   and mb-flow.js are NOT edited. mb-flow.js is a closed IIFE that posts
   { id: D.variant_id, quantity: 1 } to /cart/add.js, so this layer:

     1. mounts the pills at the top of the FIRST step's options column,
        directly above #mb-sizes (never inside it - mb-flow.js rebuilds
        #mb-sizes with innerHTML). Multi-Card hides the size buttons and
        shows Quantity / Size / Price rows; the Size dropdown clicks the
        flow's own [data-size] buttons, so the flow's state stays the truth;
     2. wraps window.fetch and, on Multi-Card, rewrites the quantity of the
        CARD line (id === D.variant_id with _mb_group) and of its size /
        slice line (_mb_parent_group, one of D.sizes[].variant_id). Extras
        are left exactly as picked. Postage is added by mb-delivery.js's own
        fetch wrapper, which runs inside this one;
     3. carries the choice through: a "Multi-Card x N" chip on every later
        step's heading, and the sticky bar total = flow total + unit x (N-1);
     4. on ?mb_edit=<key> reads that line's quantity back from /cart.js.

   On a page with a native <form action="/cart/add"> instead, the quantity is
   mirrored into its name="quantity" field (injected if missing) and the unit
   price follows pubsub variantChange / the variant id input.

   The discount is NOT applied here - an automatic discount does it at
   checkout. This only shows the customer what to expect.
   ============================================================================ */
(function () {
  'use strict';

  // MB multibuy - easy-to-change settings --------------------------------
  // Enable only once a checkout rule counts cards, excluding slice add-ons.
  var DISCOUNTS_READY = false;
  var TIERS = [            // highest threshold first
    { min: 5, pct: 20 },
    { min: 2, pct: 10 }
  ];
  var MIN_QTY = 2;         // first option in the Multi-Card dropdown
  var MAX_QTY = 10;        // last option in the Multi-Card dropdown
  var DEFAULT_QTY = 2;     // what Multi-Card starts on
  var CHIP_LABEL = 'Multi-Card';
  var CURRENCY = 'GBP';
  var LOCALE = 'en-GB';
  // ----------------------------------------------------------------------

  var el = document.querySelector('[data-mb-multibuy]');
  if (!el || el.getAttribute('data-mb-ready')) return;
  el.setAttribute('data-mb-ready', '1');

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var qtyInput = $('[data-mb-multibuy-qty]', el);
  var panel = $('[data-mb-multibuy-panel]', el);
  var select = $('[data-mb-multibuy-select]', el);
  var sizeRow = $('[data-mb-multibuy-sizerow]', el);
  var sizeSel = $('[data-mb-multibuy-size]', el);
  var badgeEl = $('[data-mb-multibuy-badge]', el);
  var wasEl = $('[data-mb-multibuy-was]', el);
  var nowEl = $('[data-mb-multibuy-now]', el);
  var nudgeEl = $('[data-mb-multibuy-nudge]', el);
  var pills = el.querySelectorAll('[data-mb-mode]');

  var flowRoot = $('[data-mb-flow]');
  var D = null;
  if (flowRoot) {
    try { D = JSON.parse($('[data-mb-flow-json]').textContent); } catch (e) { D = null; }
  }

  var prices = {};
  try { prices = JSON.parse(($('[data-mb-multibuy-prices]', el) || {}).textContent || '{}'); } catch (e) { prices = {}; }

  var initialQty = flowRoot ? parseInt(flowRoot.getAttribute('data-mb-card-quantity'), 10) || 1 : 1;
  var mode = initialQty > 1 ? 'multi' : 'single';
  var multiQty = initialQty > 1 ? Math.min(MAX_QTY, initialQty) : DEFAULT_QTY;
  var unit = parseInt(el.getAttribute('data-unit'), 10) || 0;   // pence, one card

  var fmt;
  try { fmt = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }); } catch (e) { fmt = null; }
  function money(p) {
    var v = (p || 0) / 100;
    return fmt ? fmt.format(v) : '£' + v.toFixed(2);
  }
  function tierFor(q) {
    for (var i = 0; i < TIERS.length; i++) if (q >= TIERS[i].min) return TIERS[i];
    return null;
  }
  function qty() { return mode === 'multi' ? multiQty : 1; }

  /* ---- build ----------------------------------------------------------- */
  for (var q = MIN_QTY; q <= MAX_QTY; q++) {
    var o = document.createElement('option');
    o.value = String(q);
    o.textContent = String(q);
    select.appendChild(o);
  }
  select.value = String(multiQty);

  // Same rule as sizePrice() in mb-flow.js: a bundle carries its own price.
  function sizePrice(s) {
    return (s.price_override != null) ? s.price_override : (D.base + (s.add || 0));
  }
  if (D && D.sizes && D.sizes.length > 1) {
    D.sizes.forEach(function (s) {
      var op = document.createElement('option');
      op.value = String(s.id);
      op.textContent = s.title + ' – ' + money(sizePrice(s));
      sizeSel.appendChild(op);
    });
    sizeRow.hidden = false;
  }

  /* Mount: top of the first step's options column, above the size buttons. */
  var firstScreen = null, chips = [];
  if (flowRoot) {
    var screens = $$('.mb-screen[data-step]', flowRoot);
    firstScreen = screens[0] || null;
    var sizesEl = $('#mb-sizes', firstScreen || flowRoot);
    if (sizesEl && sizesEl.parentNode) {
      sizesEl.parentNode.insertBefore(el, sizesEl);
    } else if (firstScreen) {
      var w = $('.mb-wrap', firstScreen) || firstScreen;
      w.insertBefore(el, w.firstChild);
    }
    // "Multi-Card x N" chip on every later step's heading (static markup)
    screens.slice(1).forEach(function (s) {
      var head = $('.mb-fhead', s);
      if (!head) return;
      var c = document.createElement('span');
      c.className = 'mb-mbuy__chip';
      c.hidden = true;
      head.appendChild(c);
      chips.push(c);
    });
  }
  el.hidden = false;

  /* ---- size, read from / written to the flow's own buttons ------------- */
  function currentSizeId() {
    var on = flowRoot ? $('#mb-sizes [data-size].is-on', flowRoot) || $('[data-size].is-on', flowRoot) : null;
    return on ? on.getAttribute('data-size') : (D && D.sizes && D.sizes[0] ? String(D.sizes[0].id) : null);
  }
  function flowUnit() {
    if (!D || !D.sizes) return null;
    var id = currentSizeId(), s = null;
    for (var i = 0; i < D.sizes.length; i++) {
      if (String(D.sizes[i].id) === String(id)) { s = D.sizes[i]; break; }
    }
    s = s || D.sizes[0];
    return s ? sizePrice(s) : null;
  }
  function syncSizeSel() {
    var id = currentSizeId();
    if (id != null && sizeSel.value !== String(id)) sizeSel.value = String(id);
  }
  sizeSel.addEventListener('change', function () {
    var btn = null;
    $$('#mb-sizes [data-size]', flowRoot || document).forEach(function (b) {
      if (b.getAttribute('data-size') === sizeSel.value) btn = b;
    });
    if (btn) btn.click();   // mb-flow.js's own delegated handler sets S.size and re-renders
  });

  /* The flow owns the total, including quantity, extras and postage.
     Observe its render only to synchronise the size picker, never rewrite it. */
  var barPrice = $('#mb-price');
  if (flowRoot && barPrice && window.MutationObserver) {
    new MutationObserver(function () {
      var u = flowUnit(); if (u != null) unit = u;
      syncSizeSel();
      render();
    }).observe(barPrice, { childList: true, characterData: true, subtree: true });
  }

  var stickyBar = flowRoot && flowRoot.querySelector('.mb-bar');
  if (stickyBar) {
    var sizeStickyBar = function () {
      document.documentElement.style.setProperty('--mb-flow-bar-height', Math.ceil(stickyBar.getBoundingClientRect().height) + 'px');
    };
    if (window.ResizeObserver) new ResizeObserver(sizeStickyBar).observe(stickyBar);
    sizeStickyBar();
  }

  /* ---- native forms (not used by the personalisation flow) ------------- */
  function syncForms() {
    $$('form[action*="/cart/add"]').forEach(function (f) {
      var input = f.querySelector('[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.setAttribute('data-mb-multibuy-injected', '');
        f.appendChild(input);
      }
      input.value = String(qty());
    });
  }

  /* ---- render ---------------------------------------------------------- */
  function render() {
    var n = qty();
    qtyInput.value = String(n);
    if (flowRoot) flowRoot.setAttribute('data-mb-card-quantity', String(n));
    for (var i = 0; i < pills.length; i++) {
      var on = pills[i].getAttribute('data-mb-mode') === mode;
      pills[i].classList.toggle('is-on', on);
      pills[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
    panel.hidden = mode !== 'multi';
    if (flowRoot) flowRoot.classList.toggle('mb-mbuy-on', mode === 'multi');   // hides #mb-sizes (CSS)

    if (mode === 'multi') {
      var full = unit * n;
      var t = DISCOUNTS_READY ? tierFor(n) : null;
      var pct = t ? t.pct : 0;
      var now = Math.round(full * (100 - pct) / 100);
      badgeEl.textContent = pct ? 'Save ' + pct + '%' : '';
      badgeEl.hidden = !pct;
      wasEl.textContent = pct ? money(full) : '';
      wasEl.hidden = !pct;
      nowEl.textContent = money(now);
      var top = TIERS[0];
      if (t && top && t !== top && n < top.min) {
        nudgeEl.textContent = 'Add ' + (top.min - n) + ' more to save ' + top.pct + '%';
        nudgeEl.hidden = false;
      } else {
        nudgeEl.hidden = true;
      }
    }
    chips.forEach(function (c) {
      c.textContent = CHIP_LABEL + ' × ' + n;
      c.hidden = n < 2;
    });
    if (!flowRoot) syncForms();
    var note = $('.mb-mbuy__note', el);
    if (note) note.textContent = DISCOUNTS_READY ? 'Discount applied at checkout' : 'Same card, cake flavours and message · one address. Standard postage: £5 for 2–5 cards; £8 for 6–10.';
  }

  function changed() {
    render();
    try { document.dispatchEvent(new CustomEvent('mb:multibuy:change', { detail: { quantity: qty(), mode: mode } })); } catch (e) { }
  }
  function setUnit(p) {
    p = parseInt(p, 10);
    if (isNaN(p) || p === unit) return;
    unit = p;
    render();
  }
  function setQty(n) {
    n = parseInt(n, 10) || 1;
    if (n <= 1) mode = 'single';
    else { mode = 'multi'; multiQty = Math.max(MIN_QTY, Math.min(MAX_QTY, n)); select.value = String(multiQty); }
    changed();
  }

  for (var p = 0; p < pills.length; p++) {
    pills[p].addEventListener('click', function () {
      var m = this.getAttribute('data-mb-mode');
      if (m === mode) return;
      mode = m;
      if (mode === 'multi') syncSizeSel();
      changed();
    });
  }
  select.addEventListener('change', function () {
    multiQty = parseInt(select.value, 10) || DEFAULT_QTY;
    changed();
  });

  /* ---- variant / size changes ------------------------------------------ */
  if (flowRoot) {
    var u0 = flowUnit(); if (u0 != null) unit = u0;
    syncSizeSel();
    ['mb:flow:step', 'mb:flow:restored'].forEach(function (name) {
      document.addEventListener(name, function () {
        if (name === 'mb:flow:restored') {
          var restoredQty = parseInt(flowRoot.getAttribute('data-mb-card-quantity'), 10) || 1;
          setQty(restoredQty);
        }
        syncSizeSel();
        var u = flowUnit(); if (u != null) setUnit(u);
      });
    });
  } else {
    var subscribed = false;
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (ev) {
          var v = ev && ev.data && ev.data.variant;
          if (v && v.price != null) setUnit(v.price);
        });
        subscribed = true;
      } catch (e) { }
    }
    var idInput = $('form[action*="/cart/add"] [name="id"]');
    if (idInput) {
      var fromId = function () {
        if (prices[String(idInput.value)] != null) setUnit(prices[String(idInput.value)]);
      };
      idInput.addEventListener('change', fromId);
      if (!subscribed && window.MutationObserver) {
        new MutationObserver(fromId).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }
  }

  /* ---- quantity into the flow's /cart/add.js request ------------------- */
  var prevFetch = window.fetch;
  if (flowRoot && D && typeof prevFetch === 'function') {
    var cardVid = String(D.variant_id);
    var sizeVids = (D.sizes || []).map(function (s) { return String(s.variant_id); })
      .filter(function (v) { return v && v !== 'null' && v !== '0'; });

    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var n = qty();
        if (n > 1 && init && init.body && String(url).indexOf('/cart/add') > -1) {
          if (typeof init.body === 'string') {
            var j = JSON.parse(init.body);
            if (j && Array.isArray(j.items)) {
              j.items.forEach(function (it) {
                var pr = it.properties || {};
                var vid = String(it.id);
                if (vid === cardVid && pr._mb_group) it.quantity = n;                          // the card
                else if (pr._mb_parent_group && sizeVids.indexOf(vid) > -1) it.quantity = n;   // its slices
              });
              init.body = JSON.stringify(j);
            }
          } else if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            // photo cards: the card goes alone as multipart, the rest as JSON after
            if (String(init.body.get('id')) === cardVid && init.body.get('properties[_mb_group]')) {
              init.body.set('quantity', String(n));
            }
          }
        }
      } catch (e) { /* leave the request exactly as it was */ }
      return prevFetch.apply(this, arguments.length > 1 ? [input, init] : arguments);
    };
  }

  /* ---- editing a basket line: bring its quantity back ------------------ */
  var editKey = null;
  String(window.location.search || '').slice(1).split('&').forEach(function (kv) {
    var bits = kv.split('=');
    if (decodeURIComponent(bits[0]) === 'mb_edit') editKey = decodeURIComponent(String(bits[1] || '').replace(/\+/g, ' '));
  });
  if (flowRoot && editKey) {
    prevFetch.call(window, '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (it) {
          if (it.key === editKey && it.quantity > 1) setQty(it.quantity);
        });
      })
      .catch(function () { });
  }

  changed();
})();
